import client from "../client";

export interface NotifyDepositRequest {
  bank_member_id: number;
  promotion_type_id?: number;
  amount: number;
}

export interface NotifyDepositResponse {
  success?: boolean;
  message?: string;
  transaction_id?: string;
  status?: string;
  reference_id?: string;
  amount?: number;
  fee?: number;
  net_amount?: number;
  created_at?: string;
}

export default function API(
  request: NotifyDepositRequest
): Promise<NotifyDepositResponse> {
  return client
    .post(`payment_v2/deposit/notify`, request)
    .then((response) => response.data);
}
